import { Component, Input, OnInit } from '@angular/core';
import { ClassificacaoGravidade } from 'src/app/dtos/classificacao-gravidade';

@Component({
  selector: 'app-gravidade-tag',
  templateUrl: './gravidade-tag.component.html',
  styleUrls: ['./gravidade-tag.component.less']
})
export class GravidadeTagComponent implements OnInit {

  corFundo: string = '';
  corTexto: string = '';
  icone: string = '';
  estadoTexto: string = '-';

  @Input()
  set status(v: ClassificacaoGravidade | null | undefined) {
    this.corFundo = '#fff';
    this.corTexto = '#000';
    this.estadoTexto = '-';

    switch (v) {
      case ClassificacaoGravidade.Leve:
        this.estadoTexto = 'LEVE';
          this.corFundo = '#0078D7';
          this.corTexto = '#fff';
          this.icone = '';
          break;
        case ClassificacaoGravidade.Grave:
          this.estadoTexto = 'GRAVE';
          this.corFundo = '#F03A47';
          this.corTexto = '#fff';
          this.icone = '';
        break;
        case ClassificacaoGravidade.Moderada:
          this.estadoTexto = 'MODERADO';
          this.corFundo = '#f0a13a';
          this.corTexto = '#fff';
          this.icone = '';
        break;
      default:
        break;
    }
  };
  
  constructor() { }

  ngOnInit(): void {
  }

}
